const internetNearMe = () => {
  const hsiIframe = document.getElementById('hsi-provider-widget');

  if (hsiIframe) {

    const urlParams = new URLSearchParams(window.location.search);
    let hsiScript = hsiIframe.src;

    urlParams.forEach((value, key) => {
      hsiScript = `${hsiScript}&${key}=${value}`;
    });

    $(document).ready(() => {
      hsiIframe.src = hsiScript;
    });

  }

};

export default internetNearMe;
